import type { CostSummary } from '~/subscription-management/api/common/model/cost';
import type { PreviewCostsResponse } from '~/subscription-management/api/preview-cost-changes/model';
import type { Context } from '../../checkout.machine.types';

export const DEFAULT_COST = {
  amountWithTax: 0,
  amountWithoutTax: 0,
  taxAmount: 0,
  taxRate: 0,
  purchasedProductCosts: [],
};

export const getCostsContext = (
  currentPeriodCostSummary: CostSummary | null,
  previewCostsResponse?: PreviewCostsResponse,
): Context['costs'] => ({
  payNow: previewCostsResponse?.payNow ?? null,
  renewWith: previewCostsResponse?.renewWith ?? currentPeriodCostSummary ?? DEFAULT_COST,
});
